module.exports = __webpack_public_path__ + "img/zuan-big.4a472162.png";